import { useState } from 'react';
import { WidgetButton } from '../widgetButton';
import { WidgetDivider } from '../widgetDivider';
import { WIDGET_COLORS } from '../../constants/colors';
import { formatPoints, formatDate } from '../../utils/formatSavingsPoints';
import type { SavingsPointsData } from '../../hooks/useGetSavingsPoints';
import { WidgetCardHeader } from '../widgetCardHeader';
import { ProgressItem } from '../progressItem';
import { StatRow } from '../statRow';
import { WidgetNotice } from '../widgetNotice';
import { InfoButton } from '../infoButton';
import { RestartInfoModal } from '../restartInfoModal';

type Props = { data: SavingsPointsData };

export function DipExpired({ data }: Props) {
  const [restartOpen, setRestartOpen] = useState(false);
  const earned = formatPoints(data.savings_points_earned);

  return (
    <>
      <WidgetCardHeader variant="danger" badgeText="DIP Expired" />

      <WidgetDivider />

      <ProgressItem
        label="Community Points (preserved)"
        value={
          <span className="text-gray-500">
            <strong className="text-gray-700">{earned}</strong> - held for you
          </span>
        }
        barPercent={100}
        segments={[{ flex: 1, color: WIDGET_COLORS.gray.bar }]}
      />

      <ProgressItem
        label="Queue Position"
        value={<span style={{ color: WIDGET_COLORS.gray.locked }}>- Paused</span>}
        barPercent={0}
        segments={[{ flex: 1, color: WIDGET_COLORS.gray.bar }]}
      />

      <StatRow
        bg={WIDGET_COLORS.red.bg}
        dividerColor={WIDGET_COLORS.red.divider}
        left={{ value: `${earned} pts`, valueColor: WIDGET_COLORS.red.text, label: 'Points Preserved' }}
        right={{
          value: 'TBC',
          valueColor: WIDGET_COLORS.red.text,
          label: (
            <span className="inline-flex items-center uppercase">
              New Estimated Eligibility
              <InfoButton
                onClick={() => setRestartOpen(true)}
                label="What happens next?"
                style={{ borderColor: WIDGET_COLORS.red.text, color: WIDGET_COLORS.red.text }}
              />
            </span>
          ),
        }}
      />

      <WidgetNotice variant="danger" icon="x-circle">
        Your DIP expired
        {data.dip_expiry_date && (
          <> on <strong>{formatDate(data.dip_expiry_date)}</strong></>
        )}
        . You are no longer in the queue for home finance. Give us three months&apos; notice when
        you&apos;re ready to rejoin.
      </WidgetNotice>

      <WidgetDivider />

      <WidgetButton variant="danger" onClick={() => { window.location.href = 'mailto:hello@pfida.com'; }}>
        Contact us to rejoin
      </WidgetButton>

      <RestartInfoModal open={restartOpen} onOpenChange={setRestartOpen} />
    </>
  );
}
